
export default function ContactHero() {
  return (
    <section className="relative bg-[#1A1A1A] text-white py-20 md:py-32 px-4 md:px-8 overflow-x-hidden">
      <div className="max-w-7xl mx-auto text-center">
        <h1 className="text-[30px] md:text-5xl lg:text-6xl font-bold mb-6" style={{ fontFamily: 'Montserrat, sans-serif' }}>
          Get in Touch
        </h1>
        <p className="text-base md:text-xl text-gray-300 max-w-3xl mx-auto">
          Questions about products? Need technical advice? Want to become a stockist? We're here to help.
        </p>
      </div>
    </section>
  );
}
